import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';

// Components
import SearchInput from 'components/_shared/SearchInput/SearchInput';
// SVGs
import { ReactComponent as Logo } from 'svgs/artworx_logo_v2.svg';
import { ReactComponent as Hamburger } from 'svgs/hamburger.svg';
import { ReactComponent as Close } from 'svgs/close.svg';
// Images

import location from "images/location_icon.png"
// import map from 'images/map_background_2.png';
import Search from 'images/search_icon.png';
import elevateSmall from 'images/elevate_logo_sm_v2.png';
// Constants

// Reducers
import { setSearch } from 'store/modules/db/search/searchReducer';

// Styles
import './SiteHeader.css';

export class SiteHeader extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //

  // Variables
  // ------------------------------------------------------------------------ //
  state = {
    menu: false,
    searching: false,
    search: ''
  }

  routes = {
    home: '/',
    directory: '/directory',
    pathways: '/pathways',
    report: '/report',
    "add org": '/add-org'
  };

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  // componentDidMount() {
  // }

  // Event handlers
  // ------------------------------------------------------------------------ //
  handleToggleSearch = () => {
    let state = {
      searching: !this.state.searching
    };

    if (this.state.searching) {
      state.search = '';
    }

    if (!this.state.searching) {
      state.menu = false;
    }
    this.setState(state);
  }

  handleSearch = e => {
    if (e) e.preventDefault();
    if (this.state.search.length) {
      this.props.dispatch(setSearch({ search: this.state.search }));

      this.handleCleanUp(
        () => this.props.dispatch(push('/directory'))
      );
    }
  };

  handleCleanUp = func => {
    let state = {
      searching: false,
      search: '',
      menu: false
    };
    this.setState(state, func);
  }

  handleSearchTrigger = e => {
    this.handleSearchInput(e.target.value);
  }

  handleSearchInput = value => {
    this.setState({ search: value.toLowerCase() });
  }

  handleSearchKeyDown = e => {
    let code = e.keyCode;
    if ( code !== 13 ) return;
    if (code === 13 && this.state.search.length) {
      return this.handleSearch(null);
    }
  }

  handleMenu = () => {
    let state = {
      menu: !this.state.menu
    }

    if (!this.state.menu) {
      state.searching = false
      state.search = ''
    }

    this.setState(state);
  }

  handleLink = (e, link) => {
    if (e) e.preventDefault();
    // if (this.state.menu) {
    //   this.handleMenu();
    // }
    if (this.props.path !== link) {
      this.handleCleanUp(
        () => this.props.dispatch(push(link))
      )
    }

  }

  // Class methods
  // ------------------------------------------------------------------------ //


  // Render methods
  // ------------------------------------------------------------------------ //
  renderLinks = () => {
    return (
      <ul className={`
        site-header__right
        ${this.state.menu ? 'site-header--responsive' : ''}
      `}>
        {Object.keys(this.routes).map(route => (
          <li
            key={route}
            className={`
              site-header__link
              ${this.props.path === this.routes[route] ? "site-header--active" : ""}
              `}
            onClick={e => this.handleLink(e, this.routes[route])}>
            <hr />
            <a href="#/">{route}</a>
          </li>
        ))}
        <li className={`
          site-header__link site-header__search
          ${this.state.searching ? 'site-header__searching' : ''}
          ${this.state.menu ? 'site-header__hamming' : ''}
          `}>
          {!this.state.searching ?
            (<img
              src={Search}
              alt="nav search"
              onClick={this.handleToggleSearch}
              />)
            :
           (<Close
              onClick={this.handleToggleSearch}
              alt="close" />)}
        </li>
        <li className={`
          site-header__link
          ${this.state.menu ? 'site-header__ham-close' : ''}
          site-header__ham
          `}
          onClick={this.handleMenu}>
        {!this.state.menu ?
          (<Hamburger alt="menu"/>)
          :
          (<Close alt="close" />)}
        </li>
      </ul>
    )
  }

  render() {
    return (
      <header className={`
        site-header
        ${this.state.menu ? 'site-header--responsive' : ''}
        `}>
        <div className="site-header__container">
          <div className="site-header__left">
            <a target="_blank" href="https://artworxla.org" className="site-header__logo" rel="noopener noreferrer">
              <Logo />
            </a>
            <Link to="/"><img src={elevateSmall} alt="elevate"/></Link>
          </div>
          { this.renderLinks() }
        </div>
        {this.state.searching && !this.state.menu && (
        <div className="site-header__search-module">
          <div className="site-header__search-container">
            <SearchInput
              className="site-header__search-input"
              type="search"
              name="search"
              placeholder="Search by Organization"
              value={this.state.search}
              keyDown={this.handleSearchKeyDown}
              onChange={this.handleSearchTrigger}
            />
            <div
              className="site-header__search-cta"
              onClick={this.handleSearch}>go
            </div>
          </div>
          <div className="site-header__search-directions">
            <div className="site-header__location-icon">
              <img src={location} alt="location" />
            </div>
            <article>
              <p>Looking for an organization within a specific location or sector? Try a filtered search in <span href="#" onClick={() => this.handleLink(null, '/directory')}>our Directory.</span></p>
            </article>
          </div>
        </div>)}
      </header>
    )
  }
};

export default connect(null)(SiteHeader);



// WEBPACK FOOTER //
// ./src/components/SiteHeader/SiteHeader.js